<template>
  <div class="locale-box" @click="onChange">
    <CustomIcon :name="icon" :font-size="24" />
  </div>
</template>

<script lang="ts" setup>
import CustomIcon from '@/components/CustomIcon.vue'
import { LOCALE_KEYS } from '@/locale'
import { useCommonStore } from '@/store/useCommonStore'

const store = useCommonStore()
const { locale } = useI18n()

const icon = computed<string>(() => (store.locale === LOCALE_KEYS.CN ? 'locale-cn' : 'locale-en'))

const onChange = () => {
  const isCN = store.locale === LOCALE_KEYS.CN
  const currentLang = isCN ? LOCALE_KEYS.EN : LOCALE_KEYS.CN

  locale.value = currentLang
  store.setLocale(currentLang)
}
</script>
<style>
.locale-box {
  @apply p-1;
  @apply rounded;
  @apply cursor-pointer;
  @apply hover:bg-[#22373f];
  @apply active:bg-[#0b79a3];
}
</style>
